import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import { LOAD_LIST_ONLINE_SERVICE } from '../type';
import {
  loadListOnlineServiceErrorAction,
  loadListOnlineServiceSuccessAction,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { onlineService } from 'services';

function* loadListOnlineService() {
  while (1) {
    const action = yield take(LOAD_LIST_ONLINE_SERVICE);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        onlineService.getListOnlineService,
        action.payload,
      );
      yield put(loadListOnlineServiceSuccessAction(response));
      callback && callback(response);
    } catch (error) {
      notification.error({
        message: MessengerResource.onlineService.loadListFail,
        description: error.message,
      });
      yield put(loadListOnlineServiceErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([loadListOnlineService()]);
}
